import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AuthTokenService} from '../../../../shared/services/auth-token.service';
import {SurveyService} from './../../surveys.service';
import {ClientModel, SurveyCreatePDModel} from './../../../../models/survey/survey.model';
import {ToasterService} from 'angular5-toaster/dist';

@Component({
  selector: 'app-create-tab',
  templateUrl: './create-tab.component.html',
  styleUrls: ['./create-tab.component.less']
})
export class CreateTabComponent implements OnInit {
  @Input() fromSelectedPeople: boolean;
  @Output() surveyCreatePDModelChange = new EventEmitter<SurveyCreatePDModel>();

  info: boolean;
  infoText: string;
  infoTexts: string[];
  dropdownLabel: string;
  client: string;
  newClient = false;
  dropdownLabelClient: string;
  clientListModel = new Array<ClientModel>();
  disabledDD: any;
  isAdmin = AuthTokenService.isAdmin();

  constructor(private router: Router, public surveyService: SurveyService, private toasterService: ToasterService) {
  }

  ngOnInit() {
    this.disabledDD = {
      createType: false,
      survey: true
    };

    this.clientListModel.push({id: null, name: 'New'});
    for (const a of this.surveyService.surveyCreatePDModel.listClientModel) {
      this.clientListModel.push(a);
    }

    this.dropdownLabel = 'Select';
    this.dropdownLabelClient = 'Select';

    this.infoTexts = [
      'People Data Enrichment Survey... People Data Enrichment Survey... People Data Enrichment Survey...',
      'Workshop Survey... Workshop Survey... Workshop Survey...'
    ];

    if (this.fromSelectedPeople) {
      this.disabledDD.createType = true;
      this.dropdownLabel = this.surveyService.surveyCreatePDModel.listEnumSurveyCreateType.find(a => a.value == this.surveyService.surveyCreatePDModel.selectedCreateType).name;
    }

    if (this.surveyService.surveyCreatePDModel.selectedCreateType) {
      this.dropdownLabel = this.surveyService.surveyCreatePDModel.listEnumSurveyCreateType.find(a => a.value == this.surveyService.surveyCreatePDModel.selectedCreateType).name;
    }

    if (this.surveyService.surveyCreatePDModel.clientId > 0) {
      this.dropdownLabelClient = this.surveyService.surveyCreatePDModel.listClientModel.find(a => a.id == this.surveyService.surveyCreatePDModel.clientId).name;
    }

    this.info = false;

    if (this.surveyService.surveyCreatePDModel.id == 0) {
      let e = {value: 'BrandNewSurvey', id: 'BrandNewSurvey', name: 'A brand new survey'};
      this.dropdownLabel = e.name;
      this.changeCreatedType(e);
    }
  }

  save() {//ngOnDestroy() {
    if (this.surveyService.surveyCreatePDModel.maximumNumberParticipants < 1) {
      this.toasterService.pop('error', 'Maximum number of participants must be greater then 0');
      return;
    }
    this.surveyCreatePDModelChange.emit(this.surveyService.surveyCreatePDModel);
  }


  changeClient(e) {
    this.surveyService.surveyCreatePDModel.clientName = null;
    this.surveyService.surveyCreatePDModel.clientId = e.id;
    this.newClient = e.id == null ? true : false;
  }


  changeCreatedType(e) {
    this.surveyService.surveyCreatePDModel.selectedCreateType = e.id;
    if (e.id === 'DuplicateExistingSurvey') {
      this.disabledDD.survey = false;
    } else {
      this.disabledDD.survey = true;
    }
  }

  changeSurvey(e) {
    this.surveyService.surveyCreatePDModel.selectedSurveyModelCopyFrom = e;
  }

  showInfo(text: string) {
    this.infoText = text;
    this.info = true;
  }

  onPplEnrChange(e) {
    this.surveyService.surveyCreatePDModel.isPeopleDataEnrichment = e.srcElement.checked;
    this.surveyService.surveyCreatePDModel.workshopSurvey = false;
  }

  onWrkSurChange(e) {
    this.surveyService.surveyCreatePDModel.workshopSurvey = e.srcElement.checked;
    this.surveyService.surveyCreatePDModel.isPeopleDataEnrichment = false;
  }

  onBackEnableChange(e) {
    this.surveyService.surveyCreatePDModel.backEnabled = e.srcElement.checked;
    this.surveyService.surveyCreatePDModel.isPeopleDataEnrichment = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/create-tab/create-tab.component.ts